import init from '~~/common/js/client/analytics';

export default ({ app }) => {
  if (process.client) {
    if (!app.$config.analyticsUrl) {
      throw new Error('Environment variable `analyticsUrl` is not set.');
    }
    init(app.$config.analyticsUrl);
  }
};
